<template>
  <component
    :is="$attrs.tag || 'button'"
    :href="$attrs.to"
    :class="$b({ plain })"
  >
    <slot />
  </component>
</template>

<script>
export default {
  name: 'IconButton',
  props: {
    plain: { type: Boolean, default: false }
  }
}
</script>

<style lang="postcss">
.IconButton {
  @apply flex justify-center items-center w-10 h-10 rounded-full bg-grey-light;
}

.IconButton--plain {
  @apply bg-transparent;
}
</style>
